import { render, staticRenderFns } from "./ConnectBranding.vue?vue&type=template&id=3ce0b92e"
import script from "./ConnectBranding.vue?vue&type=script&lang=js"
export * from "./ConnectBranding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports